import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

// v2 key: old 'shopos-theme' key had 'dark' saved as the default — bumping
// the key name means browsers with the old value start fresh at 'light'.
// Users who explicitly toggle after this point have their choice persisted.
const THEME_KEY = 'shopos-theme-v2';

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
};
